"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var mobx_react_1 = require("mobx-react");
var shared_1 = require("../../../../../shared");
var DefaultLegendContent_meta_1 = require("./DefaultLegendContent.meta");
var recharts_1 = require("recharts");
var Tooltip_1 = __importDefault(require("../../../../base/Tooltip"));
var Superscript_1 = __importDefault(require("../../../../base/Superscript"));
var SIZE = 32;
var DefaultLegendContent = /** @class */ (function (_super) {
    __extends(DefaultLegendContent, _super);
    function DefaultLegendContent(props) {
        var _this = _super.call(this, props) || this;
        _this.categoryKey = DefaultLegendContent_meta_1.DEFAULT_LEGEND_CONTENT_CATEGORY_KEY;
        _this.componentKey = DefaultLegendContent_meta_1.DEFAULT_LEGEND_CONTENT_COMPONENT_KEY;
        return _this;
    }
    Object.defineProperty(DefaultLegendContent.prototype, "parentComponentKey", {
        get: function () {
            return DefaultLegendContent_meta_1.DEFAULT_LEGEND_CONTENT_PARENT_COMPONENT_KEY;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Render the path of icon
     * @param {Object} data Data of each legend item
     * @return {String} Path element
     */
    DefaultLegendContent.prototype.renderIcon = function (data) {
        var inactiveColor = this.props.inactiveColor;
        var halfSize = SIZE / 2;
        var sixthSize = SIZE / 6;
        var thirdSize = SIZE / 3;
        var color = data.inactive ? inactiveColor : data.color;
        if (data.type === 'plainline') {
            return (react_1.default.createElement("line", { strokeWidth: 4, fill: "none", stroke: color, strokeDasharray: data.payload.strokeDasharray, x1: 0, y1: halfSize, x2: SIZE, y2: halfSize, className: "recharts-legend-icon" }));
        }
        if (data.type === 'line') {
            return (react_1.default.createElement("path", { strokeWidth: 4, fill: "none", stroke: color, d: "M0," + halfSize + "h" + thirdSize + "\n\t\t\t  A" + sixthSize + "," + sixthSize + ",0,1,1," + 2 * thirdSize + "," + halfSize + "\n\t\t\t  H" + SIZE + "M" + 2 * thirdSize + "," + halfSize + "\n\t\t\t  A" + sixthSize + "," + sixthSize + ",0,1,1," + thirdSize + "," + halfSize, className: "recharts-legend-icon" }));
        }
        if (data.type === 'rect') {
            return (react_1.default.createElement("path", { stroke: "none", fill: color, d: "M0," + SIZE / 8 + "h" + SIZE + "v" + SIZE * 3 / 4 + "h" + -SIZE + "z", className: "recharts-legend-icon" }));
        }
        return (react_1.default.createElement(recharts_1.Symbols, { fill: color, cx: halfSize, cy: halfSize, size: SIZE, sizeType: "diameter", type: data.type }));
    };
    /**
     * Draw items of legend
     * @return {ReactElement} Items
     */
    DefaultLegendContent.prototype.renderItems = function () {
        var _this = this;
        var _a = this.props, payload = _a.payload, iconSize = _a.iconSize, layout = _a.layout, formatter = _a.formatter;
        var viewBox = { x: 0, y: 0, width: SIZE, height: SIZE };
        var itemStyle = {
            display: layout === 'horizontal' ? 'inline-block' : 'block',
            marginRight: 10,
        };
        var svgStyle = { display: 'inline-block', verticalAlign: 'middle', marginRight: 4 };
        if (payload) {
            return payload.map(function (entry, i) {
                var finalFormatter = entry.formatter || formatter;
                var className = "recharts-legend-item legend-item-" + i + (entry.inactive && ' inactive');
                if (entry.type === 'none') {
                    return null;
                }
                var superscripts = [];
                var entryPayload = entry.payload;
                if (entryPayload && entryPayload._globalDisclaimers) {
                    // Loop through and build up the superscripts from the global disclaiemrs
                    for (var _i = 0, _a = entryPayload._globalDisclaimers; _i < _a.length; _i++) {
                        var globalDisclaimer = _a[_i];
                        for (var _b = 0, globalDisclaimer_1 = globalDisclaimer; _b < globalDisclaimer_1.length; _b++) {
                            var disclaimer = globalDisclaimer_1[_b];
                            superscripts.push(disclaimer.superscript);
                        }
                    }
                }
                // Create superscript text by joining applicable values
                var superscriptText = superscripts.join(', ');
                var superscript;
                if (superscriptText) {
                    superscript = react_1.default.createElement(Superscript_1.default, null, superscriptText);
                }
                return (react_1.default.createElement("li", { className: className, style: itemStyle, key: "legend-item-" + i },
                    react_1.default.createElement(recharts_1.Surface, { width: iconSize, height: iconSize, viewBox: viewBox, style: svgStyle }, _this.renderIcon(entry)),
                    react_1.default.createElement("span", { className: "recharts-legend-item-text" },
                        finalFormatter ? finalFormatter(entry.value, entry, i) : entry.value,
                        superscript,
                        react_1.default.createElement(Tooltip_1.default, __assign({}, (entry.payload && entry.payload.toolTip))))));
            });
        }
    };
    DefaultLegendContent.prototype.render = function () {
        var _a = this.props, payload = _a.payload, layout = _a.layout, align = _a.align;
        if (!payload || !payload.length) {
            return null;
        }
        var finalStyle = {
            padding: 0,
            margin: 0,
            textAlign: layout === 'horizontal' ? align : 'left',
        };
        return (react_1.default.createElement("ul", { className: "recharts-default-legend " + this.props.className, style: finalStyle, "data-selector": this.props['data-selector'] }, this.renderItems()));
    };
    DefaultLegendContent.displayName = 'Legend';
    DefaultLegendContent.defaultProps = {
        iconSize: 14,
        layout: 'horizontal',
        align: 'center',
        verticalAlign: 'middle',
        inactiveColor: '#ccc',
    };
    DefaultLegendContent = __decorate([
        mobx_react_1.observer
    ], DefaultLegendContent);
    return DefaultLegendContent;
}(shared_1.ComponentBase));
exports.DefaultLegendContent = DefaultLegendContent;
exports.default = shared_1.InjectedStyledComponent(DefaultLegendContent, DefaultLegendContent_meta_1.DEFAULT_LEGEND_CONTENT_CATEGORY_KEY, DefaultLegendContent_meta_1.DEFAULT_LEGEND_CONTENT_PARENT_COMPONENT_KEY, [DefaultLegendContent_meta_1.DEFAULT_LEGEND_CONTENT_COMPONENT_KEY]);
